export const checkPixel = (params) => ((params === 0 || Number(params)) && `${params}px`) || params;

// params에 단위가 붙어있지 않으면 자동으로 px 단위로 반환
